import { MESSAGES, UserRole } from '../../utils/constants'
import { MIDDLELAYER_API, SYNDEO_API } from '../../utils/constants/endpoints'
import { AXIOS_METHODS } from '../../utils/constants/enum'
import { isAxiosError } from '../../utils/helper-functions'
import { GetUserResponseType, UserHashResponse } from '../../utils/types/auth'
import { Axios } from '../axios'

export const getUser = async () => {
    try {
        const response = await Axios.syndeoInstance.get<GetUserResponseType>(
            SYNDEO_API.MY_INFO
        )
        if (response.data)
            return {
                ...response.data,
                country: response.data.country ?? 'us',
                userRole: response.data.userRole ?? UserRole.Client,
            }
        else throw new Error(MESSAGES.error.endpointError)
    } catch (error) {
        if (isAxiosError(error)) {
            if (error.response?.status === 404) {
                throw error
            } else {
                throw Error(MESSAGES.error.failedTo('Dashboard'))
            }
        }
        throw Error(MESSAGES.error.failedTo('Dashboard'))
    }
}

// export const updateUser = async (data: UpdateUserRequestPayload) =>
//     await Axios.syndeoInstance.put<null>(SYNDEO_API.MY_INFO, data)

// export const updateRole = async (role: UserRole) => {
//     try {
//         let endpoint = ''
//         switch (role) {
//             case UserRole.Provider: {
//                 endpoint = SYNDEO_API.MAKE_USER_PROVIDER
//                 break
//             }
//             case UserRole.Esthetician: {
//                 endpoint = SYNDEO_API.MAKE_USER_ESTI
//                 break
//             }
//             case UserRole.Client: {
//                 endpoint = SYNDEO_API.MAKE_USER_CLIENT
//                 break
//             }
//             default: {
//                 // impossible case
//                 throw new Error('User role not recognized.')
//             }
//         }
//         await Axios.syndeoInstance.post<null>(endpoint)
//     } catch {
//         throw Error(MESSAGES.error.failedTo('update', 'user role'))
//     }
// }

export const deleteUserService = async () => {
    try {
        await Axios.syndeoInstance.delete(SYNDEO_API.MY_INFO)
    } catch {
        throw Error(MESSAGES.error.failedTo('delete', 'user'))
    }
}

export const getFromHashService = async (hash: string) => {
    try {
        return await Axios.syndeoApiCall<{ hash: string }, UserHashResponse>(
            AXIOS_METHODS.POST,
            SYNDEO_API.USER_HASH,
            undefined,
            { hash }
        )
    } catch (e) {
        throw new Error(MESSAGES.error.failedTo('fetch data from', 'hash'))
    }
}

///////////////////////////////////////////////////////-MiddleLayer-/////////////////////////////////////////////////////////////////////

export const getAccountFromMiddleLayer = async () => {
    try {
        const response = await Axios.middleLayerInstance.get(
            MIDDLELAYER_API.GET_ACCOUNT
        )
        if (response.data)
            return {
                ...response.data,
                country: response.data.country,
                userRole: response.data.userRole ?? UserRole.Client,
            }
        else throw new Error(MESSAGES.error.endpointError)
    } catch (error) {
        if (isAxiosError(error)) {
            if (error.response?.status === 404) {
                throw error
            } else {
                throw Error(MESSAGES.error.failedTo('Dashboard'))
            }
        }
        throw Error(MESSAGES.error.failedTo('Dashboard'))
    }
}

export const updateAccount = async (updatedData: any) => {
    const data = {
        updateAccountRequestDto: {
            ...updatedData,
        },
    }

    try {
        const response = await Axios.middleLayerInstance.post(
            MIDDLELAYER_API.UPDATE_ACCOUNT,
            data
        )
        return response
    } catch (error) {
        console.log(error)
    }
}

export const fetchBeautyHealthIdData = async (beautyHealthId: string) => {
    const data = {
        providerDetails: {
            customerId: beautyHealthId,
        },
    }

    try {
        const response = await Axios.middleLayerApiCall(
            AXIOS_METHODS.POST,
            MIDDLELAYER_API.VALIDATE_CUSTOMER_ID,
            undefined,
            data
        )
        return response
    } catch (error) {
        console.log(error)
    }
}

export const validateBeautyHealthIdService = async (beautyHealthId: string) => {
    const data = {
        providerDetails: {
            customerId: beautyHealthId,
        },
    }

    try {
        const response = await Axios.middleLayerApiCall(
            AXIOS_METHODS.POST,
            MIDDLELAYER_API.VALIDATE_BHCID,
            undefined,
            data
        )
        return response
    } catch (error) {
        console.log(error)
    }
}

export const getFromMiddleLayerHashService = async (hash: string) => {
    const data = {
        providerDetails: {
            providerSignUpKey: hash,
        },
    }
    try {
        const response = await Axios.middleLayerApiCall(
            AXIOS_METHODS.POST,
            MIDDLELAYER_API.VALIDATE_PROVIDER_SIGN_UP_KEY,
            undefined,
            data
        )
        return response
    } catch (e) {
        throw new Error(MESSAGES.error.failedTo('fetch data from', 'hash'))
    }
}

export const getEstiFromKey = async (key: string) => {
    const data = {
        estiDetails: {
            estiSignUpKey: key,
        },
    }
    try {
        const response = await Axios.middleLayerApiCall(
            AXIOS_METHODS.POST,
            MIDDLELAYER_API.VALIDATE_ESTI_SIGN_UP_KEY,
            undefined,
            data
        )
        return response
    } catch (e) {
        throw new Error(MESSAGES.error.failedTo('fetch data from', 'hash'))
    }
}

export const registerSyndeoConsent = async (id: string) => {
    const data = {
        key: id,
    }
    try {
        const response = await Axios.middleLayerApiCall(
            AXIOS_METHODS.POST,
            'save-consent-status',
            undefined,
            data
        )
        return response
    } catch (e) {}
}
